import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStatus } from "@finitless/shared/hooks";
import LoginPage from "./pages/LoginPage";
import finitlessLogo from "../assets/finitless-logo.png";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, hasValidToken } = useAuthStatus();
  const navigate = useNavigate();

  useEffect(() => {
    // Navigate to home page if not authenticated
    if (!isAuthenticated || !hasValidToken) {
      navigate("/", { replace: true });
    }
  }, [isAuthenticated, hasValidToken, navigate]);

  // Show login page if not authenticated
  if (!isAuthenticated || !hasValidToken) {
    return (
      <LoginPage
        logo={finitlessLogo}
        onLoginSuccess={() => {
          navigate("/", { replace: true });
        }}
      />
    );
  }

  // Show protected content if authenticated
  return children;
};

export default ProtectedRoute;
